<template>
  <e-dialog
    v-model="modelValue"
    width="100%"
    no-border-radius
    no-content-padding
    @after-leave="onAfterLeave"
    @after-enter="onAfterEnter"
  >
    <template #title>
      <div class="d-flex align-center w-100">
        <div class="caption">
          {{ documentName }}
        </div>
        <v-spacer />
        <mobile-floating-bar>
          <div class="d-flex justify-end align-center">
            <e-btn
              variant="secondary"
              prepend-icon-src="download"
              size="M"
              class="mr-md-4"
              :loading="isDownloading"
              @click="download"
            >
              Скачать
            </e-btn>
          </div>
        </mobile-floating-bar>
      </div>
    </template>

    <pdf-viewer :src="pdf" :file-name="documentName" />

    <div v-if="$vuetify.display.smAndDown" style="height: 70px" />
  </e-dialog>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import MobileFloatingBar from '@/core/components/common/MobileFloatingBar.vue';
import PdfViewer from '@/core/components/interface/PdfViewer.vue';
import EDialog from '@/core/components/modals/Dialog.vue';
import { EBtn } from '@/core/components/ui';
import { downloadDocument } from '@/core/utils/file';
import 'vue3-pdf-app/dist/icons/main.css';

const props = defineProps<{
  documentName?: string;
  blob: Blob | undefined;
}>();

const emit = defineEmits<{
  (e: 'close'): void;
}>();

const modelValue = defineModel<boolean>();

const pdf = ref<Blob | null>(null);

const onAfterEnter = async () => {
  if (!props.blob) return;

  pdf.value = props.blob;
};

const onAfterLeave = () => {
  emit('close');
};

const isDownloading = ref(false);

const download = () => {
  if (!props.blob) return;
  isDownloading.value = true;

  downloadDocument(props.blob, `${props.documentName}.pdf`);

  isDownloading.value = false;
};
</script>
